import React, { useState, useContext, createContext, useEffect, useCallback } from 'react';
import _ from 'lodash'

// 
//  STATE FOR BUILDER SLIDEOUT ( options, etc )
// 

const builderSlideoutContext = createContext();

export function ProvideBuilderSlideout({ children }) {
  const props = useProvideBuilderSlideout();
  return <builderSlideoutContext.Provider value={props}>{children}</builderSlideoutContext.Provider>;
}

export const useBuilderSlideout = () => {
  return useContext(builderSlideoutContext);
};

function useProvideBuilderSlideout() {

  // state
  const [screen, setScreen] = useState();
  const [screenOpen, setScreenOpen] = useState(false);

  return {
    screen,
    setScreen,
    screenOpen,
    setScreenOpen
  };
}